const HisPersonAdd = ({ color, sx }) => {
  const strokeColor = color ?? "#708FBB";
  const _sx = sx ?? {};
  return (
    <svg
      style={_sx}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 20.3084V18.3742C16 17.3482 15.5786 16.3643 14.8284 15.6389C14.0783 14.9134 13.0609 14.5059 12 14.5059H6C4.93913 14.5059 3.92172 14.9134 3.17157 15.6389C2.42143 16.3643 2 17.3482 2 18.3742V20.3084"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 10.6371C11.2091 10.6371 13 8.90515 13 6.76872C13 4.6323 11.2091 2.90039 9 2.90039C6.79086 2.90039 5 4.6323 5 6.76872C5 8.90515 6.79086 10.6371 9 10.6371Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 7.73633V13.5388"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 10.6387H16"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisPersonAdd;
